import React, { useEffect, useRef, useState } from 'react';
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.css';
import moment from "moment";
import { format } from 'date-fns';
import '../../../common/rsuite-datepicker.css';
import Select, { StylesConfig } from 'react-select';
import fetchAPI from '../../../common/fetchAPI';
import { dropDownSelectionStyles, dateFormatByAccountCulture, normalizeDateFormat, getValueFromResource, dateFormatByAccountCultureForFilters } from '../../../common/timeLiveFunction';
import Loader from '../../../common/Loader';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import {
    getExpenseBilingWorksheetForDatatableAsync, setOptionExpenseNameValue, resetSelectedRecordObjectInState,
    setDateRangeValue, setOptionBilledValue, setOptionClientNameValue, setOptionEmployeeNameValue, setOptionProjectValue, setOptionExpenseTypeValue
} from "./expenseBillingSlice";
import DatePickerRanges from '../../../common/DatePickerRanges';

interface DropdownItem {
    value: number;
    label: string;
}

const ExpenseBillingWorksheetOffCanvas = (props: any) => {
    const { t } = props;
    const { sessionAccountEmployeeId, maxMenuHeight, CurrentCultureDateFormat, cultureInfoName, dateInsertionFormat } = useAppSelector(state => state.globalState);
    const AccountEmployeeId: any = sessionAccountEmployeeId;
    // const { onDateRangeChange, onhandleClientNameChange, onhandleEmployeeNameChange, onhandleProjectChange, onhandleProjectTaskChange, onhandleApprovedChange, onhandleApplyFilterOnClickEvent, onhandleResetFiltersOnClickEvent } = props;
    const dispatch = useAppDispatch();
    const { expenseBillingWorksheetList, isReload, currentPage, pageSize, isLoading, totalItems, start, recordsFiltered, timeEntryArchiveCheckedIds } = useAppSelector((state) => state.expenseBillingWorksheet);
    // const [startDate, setStartDate] = useState(new Date());
    // const [endDate, setEndDate] = useState(new Date());

    // const [clientNameArray, setClientNameArray] = useState<any | ''>([]);
    const [selectedClientNameOptionDropDown, setSelectedClientNameOptionDropDown] = useState<{ [object: string]: any }>({ value: '0', label: 'All' });

    // const [EmployeeNameArray, setEmployeeNameArray] = useState<any | ''>([]);
    // const [selectedEmployeeNameOptionDropDown, setSelectedEmployeeNameOptionDropDown] = useState<{ [object: string]: any }>({ value: '0', label: 'All' });

    // const [ProjectArray, setProjectArray] = useState<any | ''>([]);
    const [selectedProjectOptionDropDown, setSelectedProjectOptionDropDown] = useState<{ [object: string]: any }>({ value: '0', label: 'All' });

    // const [ExpenseNameArray, setExpenseNameArray] = useState<any | ''>([]);
    const [selectedExpenseNameOptionDropDown, setSelectedExpenseNameOptionDropDown] = useState<{ [object: string]: any }>({ value: '0', label: 'All' });

    const [ExpenseTypeArray, setExpenseTypeArray] = useState<any | ''>([]);
    const [selectedExpenseTypeOptionDropDown, setSelectedExpenseTypeOptionDropDown] = useState<{ [object: string]: any }>({ value: '0', label: 'All' });

    const [BilledArray, setBilledArray] = useState<any | ''>([]);
    const [selectedBilledOptionDropDown, setSelectedBilledOptionDropDown] = useState<{ [object: string]: any }>({ value: '-1', label: 'Both' });
    const [selectedEmployee, setSelectedEmployee] = useState<{ [object: string]: any }>({ value: '0', label: 'All' });
    const [search, setSearch] = useState<string>('');
    const [data, setData] = useState<DropdownItem[]>([{ value: 0, label: 'All' }]);
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [clientdata, setClientData] = useState<DropdownItem[]>([{ value: 0, label: 'All' }]);
    const [searchClient, setSearchClient] = useState<string>('');
    const [pageClient, setPageClient] = useState(1);
    const [loadingClient, setLoadingClient] = useState(false);
    const [hasMoreClient, setHasMoreClient] = useState(true);
    const [projectdata, setprojectData] = useState<DropdownItem[]>([{ value: 0, label: 'All' }]);
    const [searchProject, setSearchProject] = useState<string>('');
    const [pageProject, setPageproject] = useState(1);
    const [loadingProject, setLoadingProject] = useState(false);
    const [hasMoreProject, setHasMoreProject] = useState(true);
    const [expensedata, setExpenseData] = useState<DropdownItem[]>([{ value: 0, label: 'All' }]);
    const [searchExpense, setSearchExpense] = useState<string>('');
    const [pageExpense, setPageExpense] = useState(1);
    const [loadingExpense, setLoadingExpense] = useState(false);
    const [hasMoreExpense, setHasMoreExpense] = useState(true);
    const currentDate = new Date();
    const [SelectedStartDate, setSelectedStartDate] = useState(() => {
        const newDate = new Date();
        newDate.setMonth(newDate.getMonth() - 2);
        return newDate;
    });
    const [SelectedEndDate, setSelectedEndDate] = useState(currentDate);
    const closeButtonRef = useRef<HTMLButtonElement | null>(null);
    const [displayedRange, setDisplayedRange] = useState('Please Select Date Range');

    useEffect(() => {
        let BilledArray = [
            { value: '-1', label: 'Both' },
            { value: '1', label: 'Billed' },
            { value: '0', label: 'Not Billied' }
        ]
        setBilledArray(BilledArray);
    }, []);

    useEffect(() => {
        getAccountExpenseTypeAsync();
    }, []);

    useEffect(() => {
        fetchData(page, search);
    }, [page, search]);

    // useEffect(() => {
    //     fetchCientData(pageClient, searchClient);
    // }, [pageClient, searchClient]);

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            fetchCientData(pageClient, searchClient);
        }, 500);
        return () => clearTimeout(delayDebounceFn);
    }, [pageClient, searchClient]);

    useEffect(() => {
        fetchProjectData(pageProject, searchProject);
    }, [pageProject, searchProject]);

    useEffect(() => {
        fetchExpenseData(pageExpense, searchExpense);
    }, [pageExpense, searchExpense]);

    const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
        // const bottom = e.currentTarget.scrollHeight - e.currentTarget.scrollTop === e.currentTarget.clientHeight;
        const el = e.currentTarget;
        const bottom = el.scrollHeight - el.scrollTop <= el.clientHeight + 1;
        if (bottom && hasMore && !loading) {
            setPage((prevPage) => prevPage + 1);
        }
    }

    const customMenuList = (props: any) => {
        const { children, innerRef, maxHeight, getValue } = props;
        const handleMenuScroll = (e: React.UIEvent<HTMLDivElement>) => {
            handleScroll(e);
        }
        return (
            <div onScroll={handleMenuScroll} ref={innerRef} style={{ maxHeight, overflowY: 'auto' }}>
                {children}
            </div>
        );
    }

    const fetchData = async (pageNum: any, search: string) => {
        setLoading(true);
        try {
            const searchParam = search ? `&search=${search}` : "";
            const response: any = await fetchAPI(`api/V2/Employees/CurrentActiveNameAndIdForDropdown/${sessionAccountEmployeeId}?page=${pageNum}${searchParam}`, "GET", "", true);
            const json = await response.json();
            const transformedData = json.items.map((item: any) => ({
                value: item.id,
                label: item.text,
            }));
            const newItems = transformedData.filter((item: any) => !data.some((existingItem: any) => existingItem.value === item.value));
            setData((prevData) => [...prevData, ...newItems]);
            setHasMore(newItems.length > 0);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    const handleClientScroll = (e: React.UIEvent<HTMLDivElement>) => {
        // const bottom = e.currentTarget.scrollHeight - e.currentTarget.scrollTop === e.currentTarget.clientHeight;
        const el = e.currentTarget;
        const bottom = el.scrollHeight - el.scrollTop <= el.clientHeight + 1;
        if (bottom && hasMoreClient && !loadingClient) {
            setPageClient((prevPage) => prevPage + 1);
        }
    }

    const customMenuListClient = (props: any) => {
        const { children, innerRef, maxHeight, getValue } = props;
        const handleMenuScroll = (e: React.UIEvent<HTMLDivElement>) => {
            handleClientScroll(e);
        }
        return (
            <div onScroll={handleMenuScroll} ref={innerRef} style={{ maxHeight, overflowY: 'auto' }}>
                {children}
            </div>
        );
    }

    // const fetchCientData = async (pageNum: any, search: string) => {
    //     setLoadingClient(true);
    //     try {
    //         const searchParam = search ? `&search=${search}` : "";
    //         const response: any = await fetchAPI(`api/V2/Clients/Dropdown/0?page=${pageNum}${searchParam}`, "GET", "", true);
    //         const json = await response.json();
    //         console.log('Expense Billing Clients', json)
    //         const transformedData = json.items.map((item: any) => ({
    //             value: item.id,
    //             label: item.text,
    //         }));
    //         const newItems = transformedData.filter((item: any) => !clientdata.some((existingItem: any) => existingItem.value === item.value));
    //         setClientData((prevData) => [...prevData, ...newItems]);
    //         setHasMoreClient(newItems.length > 0);
    //     } catch (error) {
    //         console.error('Error fetching data:', error);
    //     } finally {
    //         setLoadingClient(false);
    //     }
    // };

    const fetchCientData = async (pageNum: any, search: string) => {
        setLoadingClient(true);
        try {
            const searchParam = search ? `&search=${search}` : '';
            const response: any = await fetchAPI(`api/V2/Clients/Dropdown/0?page=${pageNum}${searchParam}`, 'GET', '', true);
            const json = await response.json();
            const transformedData = json.items.map((item: any) => ({
                value: item.id,
                label: item.text
            }));
            const newItemsClients = transformedData.filter((item: any) => !clientdata.some((existingItem: any) => existingItem.value === item.value));
            setClientData((prevData) => [...prevData, ...newItemsClients]);
            setHasMoreClient(newItemsClients.length > 0);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoadingClient(false);
        }
    }

    const handleProjectScroll = (e: React.UIEvent<HTMLDivElement>) => {
        // const bottom = e.currentTarget.scrollHeight - e.currentTarget.scrollTop === e.currentTarget.clientHeight;
        const el = e.currentTarget;
        const bottom = el.scrollHeight - el.scrollTop <= el.clientHeight + 1;
        if (bottom && hasMoreProject && !loadingProject) {
            setPageproject((prevPage) => prevPage + 1);
        }
    }

    const customMenuProject = (props: any) => {
        const { children, innerRef, maxHeight, getValue } = props;
        const handleMenuScroll = (e: React.UIEvent<HTMLDivElement>) => {
            handleProjectScroll(e);
        }
        return (
            <div onScroll={handleMenuScroll} ref={innerRef} style={{ maxHeight, overflowY: 'auto' }}>
                {children}
            </div>
        );
    }

    const fetchProjectData = async (pageNum: any, search: string, AccountClientId: any = 0) => {
        setLoadingProject(true);
        try {
            const searchParam = search ? `&search=${search}` : "";
            const queryParams = new URLSearchParams();
            queryParams.append('AccountEmployeeId', AccountEmployeeId);
            queryParams.append('IsTemplate', 'false');
            queryParams.append('AccountClientId', AccountClientId);
            queryParams.append('page', pageNum);
            queryParams.append('search', search !== undefined && search !== null ? search : "");
            const response: any = await fetchAPI(`api/V2/Projects/NameAndIdByAccountId/0?${queryParams.toString()}`, "GET", "", true);
            const json = await response.json();
            const transformedProjectData = json.Data.items.map((item: any) => ({
                value: item.id,
                label: item.text
            }));
            const allOption = { value: 0, label: "All" };
            const finalProjectData = [allOption, ...transformedProjectData];
            if (pageNum === 1) {
                setprojectData(finalProjectData);
            } else {
                const newItems = transformedProjectData.filter((item: any) =>
                    !projectdata.some((existingItem: any) => existingItem.value === item.value)
                );
                setprojectData((prevData) => [...prevData, ...newItems]);
            }
            setHasMoreProject(transformedProjectData.length > 0);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoadingProject(false);
        }
    }

    const handleExpenseScroll = (e: React.UIEvent<HTMLDivElement>) => {
        // const bottom = e.currentTarget.scrollHeight - e.currentTarget.scrollTop === e.currentTarget.clientHeight;
        const el = e.currentTarget;
        const bottom = el.scrollHeight - el.scrollTop <= el.clientHeight + 1;
        if (bottom && hasMoreExpense && !loadingExpense) {
            setPageExpense((prevPage) => prevPage + 1);
        }
    }

    const customMenuExpense = (props: any) => {
        const { children, innerRef, maxHeight, getValue } = props;
        const handleMenuScroll = (e: React.UIEvent<HTMLDivElement>) => {
            handleExpenseScroll(e);
        }
        return (
            <div onScroll={handleMenuScroll} ref={innerRef} style={{ maxHeight, overflowY: 'auto' }}>
                {children}
            </div>
        );
    }

    const fetchExpenseData = async (pageNum: any, search: string) => {
        setLoadingProject(true);
        try {
            const searchParam = search ? `&search=${search}` : "";
            const response: any = await fetchAPI(`api/V2/Expenses/Dropdown/0?page=${pageNum}${searchParam}`, "GET", "", true);
            const json = await response.json();
            const transformedExpenseData = json.items.map((item: any) => ({
                value: item.id,
                label: item.text
            }));
            const newItems = transformedExpenseData.filter((item: any) => !expensedata.some((existingItem: any) => existingItem.value === item.value));
            setExpenseData((prevData) => [...prevData, ...newItems]);
            setHasMoreExpense(newItems.length > 0);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoadingProject(false);
        }
    }

    const getAccountExpenseTypeAsync = async () => {
        const response = await fetchAPI("api/v2/ExpenseTypes/ExpenseTypesForDropDown", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = await response.json();
        json.Data.map((item: any) => {
            item.value = item.AccountExpenseTypeId;
            item.label = item.ExpenseType;
            delete item.AccountExpenseTypeId;
            delete item.ExpenseType;
        });
        json.Data.unshift({ value: '0', label: 'All' });
        setExpenseTypeArray(json.Data);
    }

    const handleDateRangeChange = (value: any) => {
        // setSelectedStartDate(value[0]);
        // setSelectedEndDate(value[1]);
        // dispatch(setDateRangeValue({ startDate: value[0].toISOString(), endDate: value[1].toISOString() }));
        if (value && value[0] && value[1]) {
            const formattedStartDate = format(value[0], CurrentCultureDateFormat.toString());
            const formattedEndDate = format(value[1], CurrentCultureDateFormat.toString());
            setDisplayedRange(`${formattedStartDate} - ${formattedEndDate}`);
        } else {
            setDisplayedRange('Please Select Date Range');
        }
        // setSelectedStartDate(dateFormatByAccountCulture(value[0].toISOString(), cultureInfoName.toString()));
        // setSelectedEndDate(dateFormatByAccountCulture(value[1].toISOString(), cultureInfoName.toString()));
        // dispatch(setDateRangeValue({ startDate: dateFormatByAccountCulture(value[0].toISOString(), cultureInfoName.toString()), endDate: dateFormatByAccountCulture(value[1].toISOString(), cultureInfoName.toString()) }));
        setSelectedStartDate(dateFormatByAccountCultureForFilters(format(value[0], "yyyy-MM-dd"), cultureInfoName.toString()));
        setSelectedEndDate(dateFormatByAccountCultureForFilters(format(value[1], "yyyy-MM-dd"), cultureInfoName.toString()));
        dispatch(setDateRangeValue({ startDate: format(value[0], "yyyy-MM-dd"), endDate: format(value[1], "yyyy-MM-dd") }));
    }

    const handleProjectChange = (data: any) => {
        const { value, label } = data;
        setSelectedProjectOptionDropDown({ value: value, label: label });
        dispatch(setOptionProjectValue({ value: value, label: label }));
    }

    const handleExpenseNameChange = (data: any) => {
        const { value, label } = data;
        setSelectedExpenseNameOptionDropDown({ value: value, label: label });
        dispatch(setOptionExpenseNameValue({ value: value, label: label }));
    }

    const handleExpenseTypeChange = (data: any) => {
        const { value, label } = data;
        setSelectedExpenseTypeOptionDropDown({ value: value, label: label });
        dispatch(setOptionExpenseTypeValue({ value: value, label: label }));
    }

    const handleBilledChange = (data: any) => {
        const { value, label } = data;
        setSelectedBilledOptionDropDown({ value: value, label: label });
        dispatch(setOptionBilledValue({ value: value, label: label }));
    }

    const handleApplyFilterOnClickEvent = () => {
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
        let SearchParamsValues = `${selectedClientNameOptionDropDown.value},${selectedEmployee.value},${selectedProjectOptionDropDown.value},${selectedExpenseNameOptionDropDown.value},${selectedExpenseTypeOptionDropDown.value},${selectedBilledOptionDropDown.value},
        ${moment(SelectedStartDate).format(dateInsertionFormat)},${moment(SelectedEndDate).format(dateInsertionFormat)},${selectedClientNameOptionDropDown.label},${selectedEmployee.label},${selectedProjectOptionDropDown.label},${selectedExpenseNameOptionDropDown.label},${selectedExpenseTypeOptionDropDown.label}`;
        dispatch(getExpenseBilingWorksheetForDatatableAsync({ currentPage: 1, pageSize: pageSize, start: start, SearchParamsValues: SearchParamsValues, search: " " }));
    }

    const handleResetFiltersOnClickEvent = () => {
        setSelectedStartDate(new Date());
        setSelectedEndDate(new Date());
        // setSelectedClientNameOptionDropDown({ value: '0', label: 'All' });
        // setSelectedEmployeeNameOptionDropDown({ value: '0', label: 'All' });
        // setSelectedProjectOptionDropDown({ value: '0', label: 'All' });
        // setSelectedExpenseNameOptionDropDown({ value: '0', label: 'All' });
        // setSelectedBilledOptionDropDown({ value: '-1', label: 'Both' });
        // dispatch(resetSelectedRecordObjectInState());
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
    }

    const handleChangeOption = (selected: any) => {
        setSelectedEmployee(selected);
    }

    const handleInputChange = (inputValue: string) => {
        setSearch(inputValue);
    }

    const handleClientChange = (selected: any) => {
        setSelectedClientNameOptionDropDown(selected);
        const { value, label } = selected;
        dispatch(setOptionClientNameValue({ value: value, label: label }));
        fetchProjectData(1, "", value);
        setSelectedProjectOptionDropDown({ value: '0', label: 'All' });
    }

    const handleClientInputChange = (inputValue: string) => {
        setSearchClient(inputValue);
    }

    const handleProjectInputChange = (inputValue: string) => {
        setSearchProject(inputValue);
    }

    const handleExpenseInputChange = (inputValue: string) => {
        setSearchExpense(inputValue);
    }

    return (
        <>
            {isLoading && <Loader />}
            <div className='card-body'>
                <div className='row' >
                    <div className='col-md-12'>
                        <label className="fs-7 fs-7 fw-normal mb-2">
                            {/* {t('Date Range')} */}
                            {getValueFromResource('Date Range',dispatch, t)}
                            </label>
                        <div>
                            <DateRangePicker
                                onChange={handleDateRangeChange}
                                ranges={DatePickerRanges() }
                                value={[SelectedStartDate, SelectedEndDate]}
                                // placeholder='Please Select Date Range'
                                placeholder={displayedRange}
                                cleanable={false}
                                character={' - '}
                                placement="bottomEnd"
                                format={normalizeDateFormat(CurrentCultureDateFormat.toString())}
                            ></DateRangePicker>
                        </div>
                    </div>
                </div>
                <div className='row mt-6'>
                    <div className='col-md-12'>
                        <label className="fs-7 fs-7 fw-normal mb-2">
                            {/* {t('Employee Name')} */}
                            {getValueFromResource('Employee Name',dispatch, t)}
                            </label>
                        <div>
                            <Select
                                value={selectedEmployee}
                                className="basic-single fs-7 fw-normal"
                                classNamePrefix="select"
                                name="employeemanagerList"
                                onChange={handleChangeOption}
                                options={data}
                                styles={dropDownSelectionStyles}
                                maxMenuHeight={maxMenuHeight}
                                onInputChange={handleInputChange}
                                components={{ MenuList: customMenuList }}
                            />
                        </div>
                    </div>
                </div>
                <div className='row mt-6'>
                    <div className='col-md-12'>
                        <label className="fs-7 fs-7 fw-normal mb-2">
                            {/* {t('Client Name')} */}
                            {getValueFromResource('Client Name',dispatch, t)}
                            </label>
                        <div>
                            <Select
                                value={selectedClientNameOptionDropDown}
                                className="basic-single"
                                classNamePrefix="select"
                                isSearchable={true}
                                name="StatusList"
                                onChange={handleClientChange}
                                options={clientdata}
                                styles={dropDownSelectionStyles}
                                maxMenuHeight={maxMenuHeight}
                                onInputChange={handleClientInputChange}
                                components={{ MenuList: customMenuListClient }}
                            />
                        </div>
                    </div>
                </div>
                <div className='row mt-6'>
                    <div className='col-md-12'>
                        <label className="fs-7 fs-7 fw-normal mb-2">
                            {/* {t('Project')} */}
                            {getValueFromResource('Project',dispatch, t)}
                            </label>
                        <div>
                            <Select
                                value={selectedProjectOptionDropDown}
                                className="basic-single"
                                classNamePrefix="select"
                                isSearchable={true}
                                name="StatusList"
                                onChange={handleProjectChange}
                                options={projectdata}
                                styles={dropDownSelectionStyles}
                                maxMenuHeight={maxMenuHeight}
                                onInputChange={handleProjectInputChange}
                                components={{ MenuList: customMenuProject }}
                            />
                        </div>
                    </div>
                </div>
                <div className='row mt-6'>
                    <div className='col-md-12'>
                        <label className="fs-7 fs-7 fw-normal mb-2">
                            {/* {t('Expense Name')} */}
                            {getValueFromResource('Expense Name',dispatch, t)}
                            </label>
                        <div>
                            <Select
                                value={selectedExpenseNameOptionDropDown}
                                className="basic-single"
                                classNamePrefix="select"
                                isSearchable={true}
                                name="StatusList"
                                onChange={handleExpenseNameChange}
                                options={expensedata}
                                styles={dropDownSelectionStyles}
                                maxMenuHeight={maxMenuHeight}
                                onInputChange={handleExpenseInputChange}
                                components={{ MenuList: customMenuExpense }}
                            />
                        </div>
                    </div>
                </div>
                <div className='row mt-6'>
                    <div className='col-md-12'>
                        <label className="fs-7 fs-7 fw-normal mb-2">
                            {/* {t('Expense Type')} */}
                            {getValueFromResource('Expense Type',dispatch, t)}
                            </label>
                        <div>
                            <Select
                                value={selectedExpenseTypeOptionDropDown}
                                className="basic-single"
                                classNamePrefix="select"
                                isSearchable={true}
                                name="StatusList"
                                onChange={handleExpenseTypeChange}
                                options={ExpenseTypeArray}
                                styles={dropDownSelectionStyles}
                                maxMenuHeight={maxMenuHeight}
                            />
                        </div>
                    </div>
                </div>
                <div className='row mt-6'>
                    <div className='col-md-12'>
                        <label className="fs-7 fs-7 fw-normal mb-2">
                            {/* {t('Billed')} */}
                            {getValueFromResource('Billed',dispatch, t)}
                            </label>
                        <div>
                            <Select
                                value={selectedBilledOptionDropDown}
                                className="basic-single"
                                classNamePrefix="select"
                                isSearchable={true}
                                name="BilledList"
                                onChange={handleBilledChange}
                                options={BilledArray}
                                styles={dropDownSelectionStyles}
                                maxMenuHeight={maxMenuHeight}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className='card-footer pt-4 '>
                <div className='d-flex flex-stack float-end'>
                    <button
                        type="button"
                        className="btn btn-secondary btn-sm me-2 fs-7"
                        onClick={handleResetFiltersOnClickEvent}
                        // id="kt_OffCanvas"
                        >
                        {/* {t('Cancel')} */}
                        {getValueFromResource('Reset Filters',dispatch, t)}
                    </button>
                    <button
                        ref={closeButtonRef}
                        id='kt_OffCanvas_close'
                        type="button"
                        data-kt-element='send'
                        className="btn btn-primary btn-sm fs-7"
                        onClick={handleApplyFilterOnClickEvent}
                    >
                         <i className="bi bi-filter fs-5 me-1"></i>
                        {/* {t('Apply Filters')} */}
                        {getValueFromResource('Apply Filters',dispatch, t)}
                    </button>
                </div>
            </div>
        </>
    )
}

export default ExpenseBillingWorksheetOffCanvas